module.exports = __webpack_public_path__ + "resources/img/img_docuone2.893ae662f1f125338049e0b5b351eb43.png";